var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_21-Repeat",
    "data-name": "21-Repeat"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 47,
    width: 16,
    height: 4,
    style: {
      fill: "#1c69a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,13.29c-.09.04-.18.08-.27.13L19.01,4.99,19,4.98A31.425,31.425,0,0,1,34.2,1C49,.98,62,12.98,62,27.99c0,6-.83,10.69-3.01,15.1L63,47H47V30.99L50,34a17.049,17.049,0,0,0,.72-6.41c-.02-.17-.03-.35-.06-.52A17.864,17.864,0,0,0,34.74,11.4,17.355,17.355,0,0,0,25,13.29Z",
    style: {
      fill: "#48befd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.74,11.4A17.864,17.864,0,0,1,50.66,27.07C48.79,19.02,39.38,15,34,15c-6,0-9,3-9,3V13.29A17.355,17.355,0,0,1,34.74,11.4Z",
    style: {
      fill: "#2a84c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,55.03V59s-3,4-16,4A26.959,26.959,0,0,1,2,36.3V31.99h.02C2.02,47.04,15.01,59.03,29.78,59,37,58.99,40.47,57.57,45,55.03Z",
    style: {
      fill: "#1c69a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.76,44.46,45,55.03c-4.53,2.54-8,3.96-15.22,3.97C15.01,59.03,2.02,47.04,2.02,31.99v-.03A30.8,30.8,0,0,1,5.67,16.52L1,13H17V28.01l-3.05-3.15a18.336,18.336,0,0,0-.69,4.21c-.41,9.87,7.49,17.41,17.3,17.68A17.6,17.6,0,0,0,39.76,44.46Z",
    style: {
      fill: "#48befd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,13.29V18l-6-8V5l.01-.01,5.72,8.43C24.82,13.37,24.91,13.33,25,13.29Z",
    style: {
      fill: "#1c69a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.66,27.07A17.864,17.864,0,0,0,34.74,11.4c-.179-.017-.354-.019-.532-.031a2.473,2.473,0,0,0-.685,3.646c.16-.005.313-.015.477-.015C39.38,15,48.79,19.02,50.66,27.07Z",
    style: {
      fill: "#1c69a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5,63c.018,0,.035-.005.053-.005C29.368,63,29.189,63,29,63Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,60.5a2.476,2.476,0,0,0-.539-1.534c-.54.02-1.094.033-1.681.034C15.01,59.03,2.02,47.04,2.02,31.99H2V36.3A26.959,26.959,0,0,0,29,63c.189,0,.368,0,.553-.005A2.5,2.5,0,0,0,32,60.5Z",
    style: {
      fill: "#15507a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.98,54.5a25.054,25.054,0,0,1-25.5-24.581,2.5,2.5,0,0,0-4.306-1.644C2.066,29.464,2,30.685,2,31.96v.03a25.816,25.816,0,0,0,.586,5.477,27.751,27.751,0,0,0,18.55,20.15A27.483,27.483,0,0,0,29.76,59c1.446,0,2.736-.063,3.92-.176a2.494,2.494,0,0,0-1.7-4.324Z",
    style: {
      fill: "#6bdcff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.98,5.5a26.614,26.614,0,0,1,19.1,7.82,22.618,22.618,0,0,1,6.4,16.6A2.5,2.5,0,0,0,59.9,32.5h.083a2.483,2.483,0,0,0,1.871-.86c.08-1.168.127-2.374.127-3.65A26.628,26.628,0,0,0,51.846,7.3c-.15-.119-.3-.241-.452-.357-.123-.1-.248-.189-.373-.282a30.844,30.844,0,0,0-5.94-3.423A27.734,27.734,0,0,0,34.18,1a30.974,30.974,0,0,0-4,.274A2.5,2.5,0,0,0,31.98,5.5Z",
    style: {
      fill: "#6bdcff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,58.318c.7-.155,1.36-.334,2-.538",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.089,57A39.9,39.9,0,0,0,45,55.025L39.759,44.462a17.54,17.54,0,0,1-9.2,2.287c-9.808-.274-17.7-7.811-17.291-17.682a17.6,17.6,0,0,1,.687-4.2L17,28.009V13H1l4.665,3.52A30.86,30.86,0,0,0,2.024,31.964C2,47.02,15,59.028,29.78,59A38.382,38.382,0,0,0,35,58.674",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,55v4s-3,4-16,4A26.958,26.958,0,0,1,2,36.3V31",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,11.353a17.306,17.306,0,0,0-2,.232",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2,12a17.338,17.338,0,0,0-3.472,1.419L19,4.98A31.464,31.464,0,0,1,34.2,1C49,.978,62,12.984,62,27.991c0,6-.832,10.685-3.007,15.1L63,47H47V30.993L50,34a17.093,17.093,0,0,0,.723-6.405A17.892,17.892,0,0,0,34.738,11.4q-.37-.034-.738-.054",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "47 47 47 51 63 51 63 47",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "19 5 19 10 25 18 25 13",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,18s3-3,9-3c5.38,0,14.79,4.02,16.66,12.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.4a5de1b1a1bba53d408a68d601058774.svg";
export { ForwardRef as ReactComponent };